import { incYenOf } from '../../../lib/pricing';
const corporate = {
  // page.tsx
  'corporate.page.lastUpdated': 'Last updated: 13 June 2026',
  'corporate.page.backToTop': 'Back to top',

  // JSON-LD
  'corporate.jsonld.serviceName': 'Corporate Training — Butler-Style Hospitality Programme',
  'corporate.jsonld.orgName': 'The All Japan Butler Association',
  'corporate.jsonld.serviceType': 'Corporate Hospitality Training',
  'corporate.jsonld.areaServed': 'Japan',
  'corporate.jsonld.description': 'An on-site or academy-based corporate training programme that embeds butler-standard hospitality into your workplace. Half-day from JPY 220,000 / full day from JPY 330,000 (tax incl.).',
  'corporate.jsonld.breadcrumb1': 'Home',
  'corporate.jsonld.breadcrumb2': 'Contact',
  'corporate.jsonld.breadcrumb3': 'Corporate Training',

  // HeroSection
  'corporate.hero.homeLink': 'Home',
  'corporate.hero.contactLink': 'Contact',
  'corporate.hero.currentPage': 'Corporate Training',
  'corporate.hero.title': 'On-Site Corporate Training',
  'corporate.hero.titleEn': 'ON-SITE CORPORATE TRAINING',
  'corporate.hero.lead': 'A dispatch-style training programme where our professional butler instructors travel to your workplace, anywhere in Japan, teaching the service fundamentals cultivated by professional butlers as practical business etiquette.',
  'corporate.hero.ctaBtn': 'Enquire About On-Site Training',
  'corporate.hero.imgAlt': 'A Japanese butler instructor correcting a participant\'s posture during a corporate training session',
  'corporate.hero.badge1': 'Hands-on Practice (80% Practical)',
  'corporate.hero.badge2': 'On-Site Nationwide, or at Our Academy',
  'corporate.hero.badge3': 'The Same Instructors Who Train Our Butler Students',

  // TravelTrainingSection
  'corporate.travel.label': 'ON-SITE TRAINING',
  'corporate.travel.title': 'What Is On-Site Training?',
  'corporate.travel.subtitleEn': 'Why On-Site Training',
  'corporate.travel.lead': 'Our corporate training is delivered on-site by default: professional butler instructors travel to your workplace. The two biggest advantages are customisation to your actual environment and zero travel burden on your team.',
  'corporate.travel.point1.title': 'Customised to Your Environment',
  'corporate.travel.point1.desc': 'We design the training around your actual reception area, entrance, and vehicle drop-off, matching the real flow of your workplace. Based on a prior hearing, we build a programme tailored to your specific challenges.',
  'corporate.travel.point2.title': 'No Travel, Nationwide Coverage',
  'corporate.travel.point2.desc': 'Because our instructors come to you, your team never needs to travel to a venue. We deliver training anywhere in Japan (travel and accommodation costs billed separately).',
  'corporate.travel.point3.title': 'Hands-On Coaching in Your Real Workplace',
  'corporate.travel.point3.desc': 'Practical instruction takes place in your actual work environment, so what your team learns translates directly into their daily movements — building a level of retention classroom training alone cannot achieve.',
  'corporate.travel.img1Alt': 'Participants receiving hospitality training from a butler instructor in a company meeting room',
  'corporate.travel.img2Alt': 'A butler instructor coaching deportment at an office reception area',
  'corporate.travel.note': 'Academy-based training is also available on request. This programme does not confer a butler qualification, but we issue certificates of participation on request.',

  // PainPoints
  'corporate.pain.label': 'CHALLENGES',
  'corporate.pain.title': 'Do Any of These Challenges Sound Familiar?',
  'corporate.pain.subtitleEn': 'Common Challenges',
  'corporate.pain.lead': 'Raising the standard of guest service is one of the most pressing operational challenges organisations face today. Our butler-method training addresses these challenges through a practice-first approach that creates lasting change.',
  'corporate.pain.item1': 'We want to raise the quality of service for VIP and high-net-worth guests',
  'corporate.pain.item2': 'We are opening or refurbishing and need to establish service standards quickly',
  'corporate.pain.item3': 'Classroom-based etiquette training has not changed behaviour on the floor',
  'corporate.pain.item4': 'We want managers to have a system for maintaining consistent quality across the team',

  // IndustryCards
  'corporate.industry.label': 'INDUSTRY PROGRAMMES',
  'corporate.industry.title': 'Programmes Tailored to Your Sector',
  'corporate.industry.subtitleEn': 'Tailored for Your Industry',
  'corporate.industry.lead': 'The level of service guests expect varies by industry. We design each programme from eight sector-specific templates, optimised for your business model, guest profile, and specific challenges. We also work with luxury dining, bridal, members\' clubs, and any other service-oriented sector that puts people first.',
  'corporate.industry.viewDetail': 'Learn More',
  'corporate.industry.otherNote': 'Do not see your sector listed? Select "Other" in the industry dropdown on our enquiry form and tell us about your business.',
  'corporate.industry.hotel.name': 'Hotels & Ryokan',
  'corporate.industry.hotel.desc': 'From pre-opening training to establishing butler service standards',
  'corporate.industry.hotel.imgAlt': 'Corporate training programme for hotels and ryokan',
  'corporate.industry.residence.name': 'Luxury Residences',
  'corporate.industry.residence.desc': 'Consistent concierge and front-desk service quality',
  'corporate.industry.residence.imgAlt': 'Corporate training programme for luxury residences',
  'corporate.industry.finance.name': 'Private Banking & Finance',
  'corporate.industry.finance.desc': 'Build client trust through refined conduct and discretion',
  'corporate.industry.finance.imgAlt': 'Corporate training programme for private banking and finance',
  'corporate.industry.retail.name': 'Department Stores & Luxury Retail',
  'corporate.industry.retail.desc': 'Preferred client care and the art of the visit',
  'corporate.industry.retail.imgAlt': 'Corporate training programme for department stores and luxury retail',
  'corporate.industry.luxurySales.name': 'Luxury Sales',
  'corporate.industry.luxurySales.desc': 'Designing the client experience for high-value transactions',
  'corporate.industry.luxurySales.imgAlt': 'Corporate training programme for luxury sales',
  'corporate.industry.clinic.name': 'Aesthetic Medicine & Private Clinics',
  'corporate.industry.clinic.desc': 'Embedding premium service culture in a clinical environment',
  'corporate.industry.clinic.imgAlt': 'Corporate training programme for aesthetic medicine and private clinics',
  'corporate.industry.automotive.name': 'Automotive & Mobility',
  'corporate.industry.automotive.desc': 'Elevating the brand experience and event hospitality',
  'corporate.industry.automotive.imgAlt': 'Corporate training programme for automotive and mobility',
  'corporate.industry.chauffeur.name': 'Chauffeur & Transfer Services',
  'corporate.industry.chauffeur.desc': 'Perfecting door etiquette and in-vehicle attentiveness',
  'corporate.industry.chauffeur.imgAlt': 'Corporate training programme for chauffeur and transfer services',

  // TrainingModules
  'corporate.modules.label': 'TRAINING MODULES',
  'corporate.modules.title': 'Training Programme',
  'corporate.modules.subtitleEn': 'Six Core Modules',
  'corporate.modules.lead': 'A half-day session covers two modules; a full day covers four. Modules can be combined freely to match your sector and challenges.',
  'corporate.modules.m1.title': 'Butler-Standard Bearing & Grooming',
  'corporate.modules.m1.desc': 'We assess and correct posture, gait, and movement one by one against the butler standard. A before-and-after photo review lets participants see their own progress and feel the difference for themselves.',
  'corporate.modules.m2.title': 'Principles of VIP & High-Net-Worth Guest Service',
  'corporate.modules.m2.desc': 'Participants learn the non-negotiables of trust — forms of address, honorific language, appropriate proximity, and confidentiality — grounded in real-world examples. \n\nThe aim is to eliminate the subtle friction that wealthy guests notice instinctively and replace it with a quiet, confident assurance.',
  'corporate.modules.m3.title': 'Tea & Table Service — Practical',
  'corporate.modules.m3.desc': 'Participants practise serving tea and organising a table setting, ingraining precision into every movement. \n\nThe session covers handling fine crockery, temperature management, elegant pouring, and timing the clearance — rehearsed repeatedly until it becomes second nature.',
  'corporate.modules.m4.title': 'Handling Complaints & the Unexpected',
  'corporate.modules.m4.desc': 'Using your organisation\'s actual scenarios as the basis for role-play, participants practise the critical first response and the art of the alternative offer. The focus is on identifying what the guest truly needs and reaching a resolution swiftly, without becoming emotional.',
  'corporate.modules.m5.title': 'Dignity in Telephone, Email & Chat Communication',
  'corporate.modules.m5.desc': 'We sharpen word choice and structure so that written and spoken communications carry the same polish as in-person service. \n\nVoice tone, pacing, and message composition — the elements that distinguish outstanding non-face-to-face communication — are taught systematically.',
  'corporate.modules.m6.title': 'Team Hospitality Management',
  'corporate.modules.m6.desc': 'Designed for managers, this module establishes a cycle of standard-setting, observation, and feedback that sustains service quality across the team. \n\nThe focus is on building a management method that maintains a consistent standard for every member of staff, eliminating dependence on individuals.',

  // PricingTable
  'corporate.pricing.label': 'PRICING',
  'corporate.pricing.title': 'Pricing Plans',
  'corporate.pricing.subtitleEn': 'Transparent Pricing',
  'corporate.pricing.lead': 'All prices are inclusive of consumption tax. Choose the plan that best fits your budget and objectives.',
  'corporate.pricing.header.plan': 'Plan',
  'corporate.pricing.header.duration': 'Duration',
  'corporate.pricing.header.price': 'Fee (tax incl.)',
  'corporate.pricing.header.note': 'Content',
  'corporate.pricing.recommended': 'Standard',
  'corporate.pricing.currency': 'JPY',
  'corporate.pricing.plan1.name': 'Half-Day',
  'corporate.pricing.plan1.duration': '3 hours',
  'corporate.pricing.plan1.note': 'Choose 2 modules',
  'corporate.pricing.plan2.name': 'Full Day',
  'corporate.pricing.plan2.duration': '6 hours',
  'corporate.pricing.plan2.note': 'Choose 4 modules',
  'corporate.pricing.plan3.name': 'Two-Day Package',
  'corporate.pricing.plan3.duration': '12 hours (2 days)',
  'corporate.pricing.plan3.note': 'All 6 modules available',
  'corporate.pricing.plan4.name': 'Pre-Opening Intensive',
  'corporate.pricing.plan4.duration': '18 hours (3 days)',
  'corporate.pricing.plan4.note': 'Designed specifically for opening preparation',
  'corporate.pricing.plan5.name': 'Ongoing Programme',
  'corporate.pricing.plan5.duration': 'Half-day once a month × 6 months',
  'corporate.pricing.plan5.note': 'A long-term design built around embedding and continuous improvement',
  'corporate.pricing.options.title': 'Optional Add-ons',
  'corporate.pricing.options.currency': 'JPY (tax incl.)',
  'corporate.pricing.opt1.name': 'Mystery Service Audit',
  'corporate.pricing.opt1.price': `from ${incYenOf('ct-opt-mystery')}`,
  'corporate.pricing.opt1.note': 'On-site assessment + written report',
  'corporate.pricing.opt2.name': 'Custom Material Development',
  'corporate.pricing.opt2.price': `from ${incYenOf('ct-opt-material')}`,
  'corporate.pricing.opt2.note': 'Bespoke training text and operations manual',
  'corporate.pricing.conditions.title': 'General Conditions',
  'corporate.pricing.conditions.dispatch': 'Nationwide on-site delivery available; travel and accommodation charged at cost',
  'corporate.pricing.conditions.capacity': 'Recommended maximum 12 participants (larger groups accommodated in two parallel groups)',
  'corporate.pricing.conditions.payment': 'Payment by invoice (bank transfer). Instalment payments and credit cards are not accepted.',
  'corporate.pricing.conditions.cancel': 'Cancellation policy: Rescheduling is free of charge up to 7 business days before the session. 50% of the fee applies from 6 business days prior to the day before; 100% on the day of the session.',
  'corporate.pricing.ctaBtn': 'Enquire About Training',

  // FlowSteps
  'corporate.flow.label': 'FLOW',
  'corporate.flow.title': 'How On-Site Training Works',
  'corporate.flow.subtitleEn': 'From Enquiry to On-Site Delivery',
  'corporate.flow.lead': 'We guide you through five clear steps from initial enquiry to post-session report. For on-site training, our instructors travel to your premises on the day and tailor the programme to your venue.',
  'corporate.flow.step1.title': 'Initial Enquiry',
  'corporate.flow.step1.desc': 'Contact us via the enquiry form, telephone, or email.',
  'corporate.flow.step2.title': 'Needs Assessment',
  'corporate.flow.step2.desc': 'We discuss participant numbers, challenges, preferred timing, and your venue conditions by phone or online.',
  'corporate.flow.step3.title': 'Programme Proposal & Quotation',
  'corporate.flow.step3.desc': 'Based on the assessment, we propose a programme tailored to your venue and provide a detailed quotation.',
  'corporate.flow.step4.title': 'On-Site Delivery (Academy Option Available)',
  'corporate.flow.step4.desc': 'Our instructors travel to your premises and deliver hands-on training suited to your workplace. Academy-based training is also available on request.',
  'corporate.flow.step5.title': 'Post-Session Report',
  'corporate.flow.step5.desc': 'We provide a written summary of the session and recommendations for further development.',

  // ContactForm
  'corporate.contact.label': 'CONTACT',
  'corporate.contact.title': 'Enquiry',
  'corporate.contact.subtitleEn': 'Enquiry Form',
  'corporate.contact.lead': 'Please complete the form below and submit your enquiry.',
  'corporate.contact.phoneLead': 'You are also welcome to reach us by telephone',
  'corporate.contact.phoneOr': 'or by email',
  'corporate.contact.phoneAlso': '.',
  'corporate.contact.hours': 'Office hours: Monday – Friday 10:00–17:00 JST',
  'corporate.contact.company': 'Company Name',
  'corporate.contact.company.placeholder': 'e.g. Example Co., Ltd.',
  'corporate.contact.department': 'Department / Title',
  'corporate.contact.department.placeholder': 'e.g. HR Department, Training Manager',
  'corporate.contact.name': 'Contact Name',
  'corporate.contact.name.placeholder': 'e.g. Taro Butler',
  'corporate.contact.name.required': 'Required',
  'corporate.contact.name.error': 'Contact name is required',
  'corporate.contact.email': 'Email Address',
  'corporate.contact.email.placeholder': 'e.g. taro@example.com',
  'corporate.contact.email.required': 'Required',
  'corporate.contact.email.error': 'Email address is required',
  'corporate.contact.email.invalid': 'Please enter a valid email address',
  'corporate.contact.phone': 'Telephone Number',
  'corporate.contact.phone.placeholder': 'e.g. +81-90-1234-5678',
  'corporate.contact.phone.required': 'Required',
  'corporate.contact.phone.error': 'Telephone number is required',
  'corporate.contact.industry': 'Industry',
  'corporate.contact.industry.required': 'Required',
  'corporate.contact.industry.error': 'Please select your industry',
  'corporate.contact.format': 'Preferred Delivery Format',
  'corporate.contact.participants': 'Estimated Participants',
  'corporate.contact.participants.placeholder': 'e.g. 10',
  'corporate.contact.timeline': 'Preferred Timing',
  'corporate.contact.timeline.placeholder': 'e.g. Next month, this financial year, undecided',
  'corporate.contact.message': 'Message (optional)',
  'corporate.contact.message.placeholder': 'Please share your training objectives, specific requirements, or any questions you have.',
  'corporate.contact.message.error': 'Please keep your message to 500 characters or fewer',
  'corporate.contact.submit.error': 'An error occurred during submission. Please try again or contact us by telephone.',
  'corporate.contact.submit': 'Submit Enquiry',
  'corporate.contact.submitting': 'Sending...',
  'corporate.contact.industry.select': 'Please select',
  'corporate.contact.industry.hotel': 'Hotels & Ryokan',
  'corporate.contact.industry.residence': 'Luxury Residences',
  'corporate.contact.industry.finance': 'Finance',
  'corporate.contact.industry.retail': 'Department Stores & Retail',
  'corporate.contact.industry.luxurySales': 'Luxury Sales',
  'corporate.contact.industry.clinic': 'Medical & Clinic',
  'corporate.contact.industry.automotive': 'Automotive & Mobility',
  'corporate.contact.industry.chauffeur': 'Chauffeur & Transfer',
  'corporate.contact.industry.other': 'Other',
  'corporate.contact.format.select': 'Please select',
  'corporate.contact.format.dispatch': 'On-site',
  'corporate.contact.format.onsite': 'At the Academy',
  'corporate.contact.format.undecided': 'Undecided',

  // FAQSection
  'corporate.faq.label': 'FAQ',
  'corporate.faq.title': 'Frequently Asked Questions',
  'corporate.faq.subtitleEn': 'Frequently Asked Questions',
  'corporate.faq.otherNote': 'For further questions, please use the enquiry form',
  'corporate.faq.q1': 'How many participants can attend a single session?',
  'corporate.faq.a1': 'We recommend a maximum of 12 participants to maintain the quality of practical training. For larger groups we can propose running two parallel groups or holding multiple sessions — please get in touch to discuss.',
  'corporate.faq.q2': 'Can training be delivered outside Tokyo?',
  'corporate.faq.a2': 'Yes, we deliver training nationwide. Travel and accommodation costs for instructors are charged separately at cost.',
  'corporate.faq.q3': 'Can the programme be customised?',
  'corporate.faq.a3': 'Yes. Following a needs assessment, we design the programme by combining modules and incorporating examples from your own organisation to address your specific challenges.',
  'corporate.faq.q4': 'What payment methods are accepted?',
  'corporate.faq.a4': 'Payment is accepted by invoice (bank transfer). Instalment payments and credit cards are not accepted.',

  // CTASection
  'corporate.cta.label': 'GET STARTED',
  'corporate.cta.title': 'We Would Love to Hear From You',
  'corporate.cta.lead': 'Tell us about your challenges and we will propose the most suitable training plan — at no charge.',
  'corporate.cta.inquiryBtn': 'Enquire About Training',
  'corporate.cta.coursesBtn': 'View Individual Courses',

  // RelatedPages
  'corporate.related.label': 'RELATED',
  'corporate.related.title': 'Related Pages',
  'corporate.related.subtitleEn': 'See Also',
  'corporate.related.viewDetail': 'Learn More',
  'corporate.related.coursesLink': 'View Individual Courses (Butler Training Programme)',
  'corporate.related.page1.title': 'About the Academy',
  'corporate.related.page1.desc': 'Our philosophy and overview',
  'corporate.related.page2.title': 'Curriculum',
  'corporate.related.page2.desc': 'An overview of our butler training programme',
  'corporate.related.page3.title': 'Instructors',
  'corporate.related.page3.desc': 'Coming soon',
  'corporate.related.page4.title': 'Access',
  'corporate.related.page4.desc': 'Directions to our academy in Odaiba, Tokyo',
};

export default corporate;
